export { default } from './page-nav';
export type { IPageNavItem } from './page-nav';
